import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

/**
 * Custom hook to track page views with Google Analytics
 * This helps with more accurate analytics data for SEO analysis
 */
const useGaPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on location change
    const currentPath = location.pathname + location.search;
    ReactGA.send({ hitType: "pageview", page: currentPath });
    
    // Also track with the document title for better analytics data
    const pageTitle = document.title || 'Cosmik Drones';
    ReactGA.send({ 
      hitType: 'pageview', 
      page: currentPath,
      title: pageTitle
    });
    
  }, [location]);
};

export default useGaPageTracker; 